import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconEyeOff = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      d="m17.778 15.648-2.681-2.697c.138-.223.246-.484.322-.784.076-.3.114-.603.114-.91 0-.989-.343-1.828-1.029-2.518-.685-.69-1.52-1.035-2.504-1.035-.305 0-.603.035-.894.105-.291.07-.554.181-.79.334L8.03 5.823c.485-.223 1.105-.418 1.86-.585a10.174 10.174 0 0 1 2.214-.251 9.28 9.28 0 0 1 5.175 1.547c1.58 1.03 2.785 2.418 3.617 4.16.041.07.07.153.083.25a2.473 2.473 0 0 1 0 .637.681.681 0 0 1-.083.262 10.04 10.04 0 0 1-1.33 2.111 9.819 9.819 0 0 1-1.788 1.694Zm.748 4.264-3.034-2.99a8.04 8.04 0 0 1-1.642.45 10.93 10.93 0 0 1-1.85.157 9.482 9.482 0 0 1-5.259-1.547c-1.593-1.031-2.806-2.418-3.637-4.16a.884.884 0 0 1-.083-.261A2.014 2.014 0 0 1 3 11.258a1.659 1.659 0 0 1 .104-.585 9.93 9.93 0 0 1 1.112-1.83c.45-.592.98-1.153 1.59-1.682L3.623 4.966a.603.603 0 0 1-.187-.439c0-.167.063-.314.187-.439A.608.608 0 0 1 4.07 3.9a.61.61 0 0 1 .447.188L19.4 19.055a.555.555 0 0 1 .167.407.63.63 0 0 1-.167.429.52.52 0 0 1-.426.209.608.608 0 0 1-.447-.188ZM12 14.812a4 4 0 0 0 .623-.053c.222-.035.41-.087.562-.157l-4.51-4.536a2.57 2.57 0 0 0-.157.565 3.83 3.83 0 0 0-.052.627c0 1.003.347 1.846 1.04 2.53A3.427 3.427 0 0 0 12 14.81Zm2.182-2.78-2.951-2.969c.859-.32 1.656-.153 2.39.502.734.655.921 1.477.561 2.466Z"
    />
  </svg>
);
const Memo = memo(SvgIconEyeOff);
export default Memo;
